import { render } from "./Qualification.component.vue?vue&type=template&id=2a0f3c0b&scoped=true"
import script from "./Qualification.component.vue?vue&type=script&lang=js"
export * from "./Qualification.component.vue?vue&type=script&lang=js"

import "./Qualification.component.vue?vue&type=style&index=0&id=2a0f3c0b&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a0f3c0b"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
